module.exports = __webpack_public_path__ + "img/big_circle.270c609d.png";